import { Toaster } from 'sonner';

// Provider component to mount Sonner's Toaster globally
export const Toast = () => {
  return <Toaster position="top-center" richColors closeButton />;
};
